// Shared non-content states of the insights screens (§2.8): loading, the
// crisis lock (points to SOS), and the error retry. Renders the page
// content once data is ready. The 409 subscription state is a fallback
// for a stale backend only: since §2.8 «Before Payment» the endpoint
// answers pre-handover users with before_payment=true instead of 409.

import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { useInsightsData } from '../model/useInsightsData'
import styles from './InsightsGate.module.css'

type InsightsData = ReturnType<typeof useInsightsData>

export default function InsightsGate({ insights, children }: { insights: InsightsData; children: ReactNode }) {
  const { phase, data, retry } = insights

  if (phase === 'loading') {
    return (
      <div className={styles.wrap}>
        <div className={styles.centered}>
          <div className={styles.spinner} />
          <p>Загружаем инсайты…</p>
        </div>
      </div>
    )
  }

  if (phase === 'locked') {
    return (
      <div className={styles.wrap}>
        <div className={styles.centered}>
          <p className={styles.title}>Раздел временно закрыт</p>
          <p className={styles.note}>
            Сейчас рядом поддержка, которая важнее статистики. Контакты помощи —
            на странице SOS.
          </p>
          <Link className={styles.btn} to="/sos">Открыть SOS</Link>
        </div>
      </div>
    )
  }

  if (phase === 'no-subscription') {
    return (
      <div className={styles.wrap}>
        <div className={styles.centered}>
          <p className={styles.title}>Инсайты откроются после подписки</p>
          <p className={styles.note}>
            Бот собирает инсайты из ваших разговоров — первый появится после
            первой оплаченной беседы.
          </p>
          <Link className={styles.btn} to="/pricing">Посмотреть тарифы</Link>
        </div>
      </div>
    )
  }

  if (phase === 'error' || !data) {
    return (
      <div className={styles.wrap}>
        <div className={styles.centered}>
          <p>Не удалось загрузить инсайты.</p>
          <button type="button" className={styles.btn} onClick={retry}>Повторить</button>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
